import { Components } from '@mui/material/styles';

const CDS_helperText: Partial<Components> = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0
        // Add more custom styles as needed
      }
    }
  }
};

export default CDS_helperText;
